var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_vm._v(_vm._s(_vm.prepareHash(_vm.address))),(_vm.address)?_c('CopyBtn',{staticClass:"ml-2",attrs:{"value":_vm.address}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }